import React from 'react';
import {JBFS_ORANGE_BASE} from "../../../constants";
import ReactLoading from "react-loading";

const LoadingSimple = (props) => {

    let loadComponent = <ReactLoading type={props.type ? props.type : "bubbles"}
                                      color={JBFS_ORANGE_BASE}
                                      className={props.position ? '' : ["loading-margin"]}/>
    if (props.size === 'small') {
        loadComponent = <ReactLoading type={props.type ? props.type : "bubbles"}
                                      color={JBFS_ORANGE_BASE}
                                      className={props.position ? '' : ["loading-margin"]} width={"30px"} height={"30px"}/>
    }

    return (loadComponent);
}

export default LoadingSimple